import { FC, useEffect, Fragment, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import {
  PatientInitialStateType,
  ReduxScreenNavType,
  ScreenInitialStateType,
  UserInitialStateType,
} from "DataTypes/Redux";
import { useDispatch, useSelector } from "react-redux";
import { CPNavArr, RPMNavArr } from "./Data";
import { setAlertData, setNavArr, setRightHead } from "Redux/Screen/Action";
import { CareNavType } from "DataTypes/PatientManagement.type";
import { RouteUrls } from "Constant/RouteUrls";
import { addSelectedPrgm } from "Redux/Patient/Action";
import { selectedPrgmInitialState } from "Redux/Patient/reducer";
import CarePlanApi from "Service/CarePlan.api";
import { Loader } from "Components";
import CPFormatter from "Utils/CP.Formatter";
import { ConvertStringToNum } from "Utils/common";
import useMonthEndSchedulerWithSmartCountdown from
  "Hooks/useMonthEndSchedulerWithSmartCountdown";

const RevisionPlan: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { patientInfo, selectedPrgm }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const { navArr }: ScreenInitialStateType = useSelector(
    (state: any) => state?.screen
  );
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const [loading, setLoading] = useState(true);
  const isRPM = selectedPrgm.abbrevation == "RPM";
  const { careplanId } = useParams();
  const newCPId = ConvertStringToNum(careplanId);
  useMonthEndSchedulerWithSmartCountdown({
    orgTimezone: "Asia/Kolkata",
    onForceExit: (alertText) => {
      dispatch(setAlertData({
        alertMessage: alertText,
        alertVariant: "info",
        openAlert: true,
      }))
      navigate(`../${RouteUrls.clinicalSummary}`);
    },
    showCountdownOnUI: selectedPrgm.showLogTime,
    bufferTimeInSec: 60
  });

  useEffect(() => {
    dispatch(setRightHead("care-plan"));
    handleInitalLoad();
    return () => {
      dispatch(setRightHead(""));
      dispatch(addSelectedPrgm({ ...selectedPrgmInitialState }));
    };
  }, [newCPId]);

  useEffect(() => {
    dispatch(
      setNavArr([
        ...navArr.filter((el) => el.level < 4),
        ...handleNavArr(),
      ])
    );
    return () => {
      dispatch(setNavArr([...navArr.filter((el) => el.level < 4)]));
    };
  }, [selectedPrgm.careplanId, selectedPrgm.careplanStage]);

  const handleInitalLoad: () => void = async () => {
    setLoading(true);
    const payload = {
      careplanId: selectedPrgm.careplanId,
    };
    const res = await CarePlanApi.GenericInfo({ data: payload });
    if (res?.success) {
      const checkedRes = CPFormatter.CPGenericInfo(res?.data);
      const isSTM = checkedRes.teamMember && myInfo.roleId != 4 ? true : false;
      dispatch(
        addSelectedPrgm({
          ...selectedPrgm,
          ...checkedRes,
          careplanActivity: checkedRes.abbrevation + " Revision",
          careplanState: selectedPrgm.careplanState,
          careplanStage: selectedPrgm.careplanStage,
          showLogTime: selectedPrgm.showLogTime,
          recurringPlanningMonth: selectedPrgm.recurringPlanningMonth,
          recurringPlanningYear: selectedPrgm.recurringPlanningYear,
          readOnlyArr: selectedPrgm.readOnlyArr,
          callDefaultRoute: selectedPrgm.callDefaultRoute,
          showSaveBtn: selectedPrgm.showSaveBtn,
          showSubmitBtn: selectedPrgm.showSubmitBtn,
          seniorTeamMember: isSTM,
          billableproviderId: selectedPrgm.billableproviderId,
          providerId: selectedPrgm.providerId,
          caremanagerId: selectedPrgm.caremanagerId,
          teamInitiatorRoleId: selectedPrgm.teamInitiatorRoleId,
          teamInitiatedBy: selectedPrgm.teamInitiatedBy,
        })
      );
    } else navigate(-1);
    setLoading(false);
  };

  const handleNavArr: () => ReduxScreenNavType[] = () => {
    const newArr: CareNavType[] = (isRPM ? RPMNavArr : CPNavArr).filter(
      (el) => el.stage <= selectedPrgm.careplanStage
    );
    return newArr.map((el) => {
      return {
        id: el.id,
        label: el.label,
        path: `/${RouteUrls.hs}/${RouteUrls.patient}/${patientInfo.id}` +
          `/${RouteUrls.revisionPlan}/${selectedPrgm.careplanId}/${el.path}`,
        level: el.level,
        link: el.link,
        navType: "patient",
      };
    });
  };

  return (
    <Fragment>{selectedPrgm && loading ? <Loader /> : <Outlet />}</Fragment>
  );
};

export default RevisionPlan;
